import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import DashboardHeader from '../../components/dasboardHeader/index.vue'
import SideNav from '../../components/sideNavBar/index.vue'

export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  data () {
    return {}
  },
  mounted () {
    // window.analytics.page('branchSetupYourMaster')
    window.analytics.identify('branchSetupYourMaster', {
      path: '/branchSetupYourMaster'
    })
  },
  components: {
    DashboardHeader,
    SideNav
  }
}
